import { gql } from '@apollo/client';

export const GET_PARK_ZONE = gql`
  query parkZone($uid: String!) {
    parkZone(uid: $uid) {
      uid
      name
      locationType
      countryCode
      commerciallyActive
      address {
        street
        number
        city
        marker
      }
      area
      commercialZoneView {
        zoneCode
        name
      }
      parkingFacilityUid
      parkingFacility {
        timeSlots {
          type
          weekDay
          startTime
          endTime
        }
      }
      parkingMethods {
        anpr
        unmanagedParking
        parkingAbuseFix
        evCharging
        manualStart
      }
      info {
        doorCode
        hasParkingCapacity
      }
      notes {
        type
        text {
          fi
          sv
          en
          no
        }
        priority
        visibility
        startDate
        endDate
      }
      markerType
      serviceChannelCodes
      spotMap
      visibility
      capacityV2 {
        total
        free
        full
        capacityStatus
      }
      benefits {
        admissionTypes
        benefitTargetType
        benefitTargetUid
        benefitUid
        memberGroupUid
      }
    }
  }
`;
